






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { renewSet } from "@/api/renewal";
interface searchFormInter {
  delivery: boolean;
  time: string;
  surplus_class_hour: string;
}
@Component({
  name: "setUpdialog",
})
export default class extends Vue {
  @Prop() dialogType!: string;
  dialogVisible: boolean = false;
  form = {
    renew_push_time: "09:00",
    renew_auto_switch: true,
    renew_lesson_count: "5",
  };
  rules = {
    renew_push_time: [
      { required: true, message: "请选择推送时间", trigger: "change" },
    ],
    renew_auto_switch: [{ required: true }],
    renew_lesson_count: [{ required: true, message: "请输入剩余课时" }],
  };
  created() {
    const switchDetail: any = localStorage.getItem("switch_type");
    if (switchDetail !== null) {
      if (JSON.parse(switchDetail).renew_push_time) {
        this.form.renew_push_time = JSON.parse(
          switchDetail
        ).renew_push_time.slice(0, 5);
      }
      this.form.renew_auto_switch = JSON.parse(switchDetail).renew_auto_switch;
      this.form.renew_lesson_count =
        JSON.parse(switchDetail).renew_lesson_count;
    }
  }
  isnumber(val: any) {
    val = val.replace(/[^0-9]/gi, "");
    // 此处还可以限制位数以及大小
    if (val.length > 5) {
      return Number(val.slice(0, 5));
    }
    return Number(val);
  }
  closeView() {
    this.dialogVisible = false;
  }
  keepClick() {
    const _t = this as any;
    const data = {
      renew_auto_switch: this.form.renew_auto_switch == true ? 1 : 2,
      renew_push_time: this.form.renew_push_time + ":00",
      renew_lesson_count: Number(this.form.renew_lesson_count),
    };
    _t.$refs["mainForm"].validate((valid: boolean) => {
      if (valid) {
        renewSet(data as any).then((res) => {
          this.$message({
            type: "success",
            message: "设置完毕!",
          });
          this.dialogVisible = false;
        });
      }
    });
  }
  showDialog() {
    this.dialogVisible = true;
  }
}
